import * as ng from 'angular';

export class MoleculeButtonDownloadCsvController implements ng.IController {
    public static $inject: string[] = [];

    public disabled: boolean;
    public downloadMethod: (arg0: any) => void;
    private item: any;

    public onClick = () => {
        this.downloadMethod(this.item);
    };
}

export class MoleculeButtonDownloadCsvComponent implements ng.IComponentOptions {
    public transclude = true;
    public bindings = {
        disabled: '<',
        downloadMethod: '<',
        item: '<'
    };
    public controller =  MoleculeButtonDownloadCsvController;
    public template = require('./button-download-csv.html');
}
